import { Summary } from './primitives';
import type { SummarySlice } from './types';

export const renewalSummarySummaries = {
  'renewal_summary.generated': () => <Summary>Summary of changes generated</Summary>,
  'renewal_summary.regenerated': () => <Summary>Summary of changes regenerated</Summary>,
} satisfies SummarySlice;
